import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CONTENT } from "@/content";
import { useSettings } from "@/lib/settings";

const G = CONTENT.home.storyGlimpse;
const EASE = [0.2, 0.7, 0.3, 1];

export const StoryJourney = () => (
  <section className="journey" data-testid="story-glimpse-card">
    <motion.div className="journey-head" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.3 }}>
      <span className="pill" data-testid="story-glimpse-label">{G.label}</span>
      <h2 className="section-title" data-testid="story-glimpse-title">{G.title}</h2>
      <div className="story-lines">
        {useSettings().settings.site.story_glimpse.split("\n").filter((l) => l.trim()).map((l, i) => <p key={i} data-testid={`story-glimpse-line-${i + 1}`}>{l}</p>)}
      </div>
    </motion.div>

    <div className="journey-track">
      <motion.span
        className="journey-line"
        aria-hidden="true"
        initial={{ scaleX: 0, scaleY: 0 }}
        whileInView={{ scaleX: 1, scaleY: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1.6, ease: "easeInOut" }}
      />
      {G.steps.map((s, i) => (
        <motion.article
          key={s.title}
          className="journey-step"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: i * 0.25, ease: EASE }}
          data-testid={`journey-step-${i + 1}`}
        >
          <span className="journey-dot" aria-hidden="true"><span className="mini-ripple" style={{ animationDelay: `${i * 0.4}s` }} /></span>
          <img src={s.image.src} alt={s.image.alt} className="journey-img" loading="lazy" />
          <span className="journey-date">{s.date}</span>
          <h3 className="journey-title">{s.title}</h3>
          <p className="journey-text">{s.text}</p>
        </motion.article>
      ))}
    </div>

    <Link to={G.linkTo} className="text-link journey-link" data-testid="read-full-story-link">
      {G.linkLabel} <span aria-hidden="true">→</span>
    </Link>
  </section>
);
